import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { SEARCH_MODULE_NAMESPACE } from '../../../../store/search';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)

@Component
class TicketSideBarModal extends Vue {
  dtRules: { nameRules?: any, independentContractor?: any }
  /**
   *
   */
  constructor() {
    super();
    this.dtRules = {}
  }

  @Prop({ default: false, type: [Boolean] })
  visible: boolean;

  @SearchStore.Getter declarants: any[];
  @UserStore.Getter userInfo: { id: number };

  @Prop({ default: { name: '', participants: [] }, type: [Object] })
  value: { name: string, participants: number[] }

  @Prop({ default: false, type: [Boolean] })
  loading: boolean;

  get coDeclarants() {
    return this.declarants.filter(d => d.id !== this.userInfo.id);
  }
  get name(): string {
    return this.value.name;
  }
  set name(val: string) {
    this.$emit('input', { ...this.value, name: val });
  }
  get participants(): any {
    return this.value.participants;
  }
  set participants(val: any) {
    this.$emit('input', { ...this.value, participants: val });
  }
  get lblSetting() {
    return {
      ...require('../../../../locales/validation-messages').default,
      ...require('../../../../locales/ticket').default
    };

  }
  get coModalVisible(): boolean {
    return this.visible;
  }
  set coModalVisible(value: boolean) {
    this.$emit('update:visible', value)
  }

  created() {
    this.dtRules = {
      nameRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.ticketGroup) }),
        v => (!!v && v.length <= 60) || this.$t(this.lblSetting.maxlengthRequired, { length: 60 }),
      ],
      independentContractor: [(v) => !!v && v.length > 0 || this.$t(this.lblSetting.groupMemberRequired)],
    }
  }

  @Emit('save')
  handleSave(event) { }
}

export default TicketSideBarModal;


// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-sidebar-modal/index.ts